<template>
    <div style="padding:20px; height: 100vh; background-color: black; color: white;" v-if="dataReady">
        <div class="row" style="height: 50%;">
            <!-- <div class="row" style="height: 100%;" v-if="shiftType == 0"> -->
            <div class="col-10 flexBox">
                <div class="row flexTop">
                    <div class="col-3">
                        <h2>Shift Pagi</h2>
                    </div>
                    <div class="col-3">
                        <h3 style="text-decoration: underline;">
                            <span style="font-weight:normal">Overall Total : </span>{{totalDaily.day[totalDaily.day.length-1] + totalDaily.night[totalDaily.night.length-1]}}
                        </h3>
                    </div>
                    <div class="col-6">
                        <div id="clock">
                            <p>
                                <span class="date" style="font-size:125%; margin-right:10px">{{clock.date}}</span>
                                <span class="time" style="font-size: 250%">{{ clock.time }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="flexContent">
                    <table class="table" style="color: white; height: 100%;">
                        <thead>
                            <tr>
                                <th scope="col">Hour</th>
                                <th scope="col" v-for="x in monthLength" :class="{ 'boxHigh' : x-1 == currDate }">{{x}}</th>
                                <th scope="col">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="x in 9">
                                <th scope="row">{{times.all[x-1]}}</th>
                                <td v-for="(map, len) in data[x-1].value" :class="{ 'boxMid' : len == currDate, 'dataAvailable' : map >  0, 'currentTime' : isCurrent(x-1, len) }">{{ map }}</td>
                                <td>{{ data[x-1].total }}</td>
                            </tr>
                            <tr>
                                <th scope="row">Total</th>
                                <td v-for="(tot, len) in totalDaily.day" :class="{ 'boxLow' : len == currDate }">{{ tot }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-2 outerLayer">
                <div class="innerLayer">
                    <table class="table type" style="color: white;">
                        <thead>
                            <tr>
                                <th scope="col" style="border-top-left-radius: 20px;">Vehicle</th>
                                <th scope="col" style="border-top-right-radius: 20px">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="type in dataType.pagi">
                                <td v-if="type.type">{{type.type}}</td>
                                <td v-else>No Type</td>
                                <td>{{type.qty}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="row" style="height: 50%;">
            <div class="col-10 flexBox">
                <div class="row flexTop">
                    <div class="col-4">
                        <h2>Shift Malam</h2>
                    </div>
                    <div class="col-8">
                        <!-- <h3><span style="font-weight:normal;">Total : </span>{{totalDaily.night[totalDaily.night.length-1]}}</h3> -->
                    </div>
                </div>
                <div class="flexContent">
                    <table class="table" style="color: white; height: 100%;">
                        <thead>
                            <tr>
                                <th scope="col">Hour</th>
                                <th scope="col" v-for="x in monthLength" :class="{ 'boxHigh' : x-1 == currDate }">{{x}}</th>
                                <th scope="col">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="x in 8">
                                <th scope="row">{{times.all[x+8]}}</th>
                                <td v-for="(map, len) in data[x+8].value" :class="{ 'boxMid' : len == currDate, 'dataAvailable' : map > 0 }">{{ map }}</td>
                                <td>{{ data[x+8].total }}</td>
                            </tr>
                            <tr>
                                <th scope="row">Total</th>
                                <td v-for="(tot, len) in totalDaily.night" :class="{ 'boxLow' : len == currDate }">{{ tot }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-2 outerLayer">
                <div class="innerLayer">
                    <table class="table type" style="color: white;">
                        <thead>
                            <tr>
                                <th scope="col" style="border-top-left-radius: 20px;">Vehicle</th>
                                <th scope="col" style="border-top-right-radius: 20px;">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="type in dataType.malam">
                                <td v-if="type.type">{{type.type}}</td>
                                <td v-else>No Type</td>
                                <td>{{type.qty}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- <button type="button" class="btn btn-primary" @click="printDataType()">Test</button> -->
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default{
        data(){
            var now = new Date();
            var currDate = now.getDate() - 1;
            var currMonth = now.getMonth();
            // var currMonth = 0;
            var currYear = now.getFullYear();
            var monthLength = new Date(currYear , currMonth + 1 , 0).getDate();


            return {
                currDate : currDate,
                currMonth : currMonth,
                currYear : currYear,
                totalPerHour : {},
                monthLength : monthLength,
                overallTotal : {
                    "pagi" : 0,
                    "malam" : 0,
                    "all" : 0,
                },
                times : {
                    "day" : [],
                    "night" : [],
                    "all" : [],
                },
                data : [],
                totalDaily : {
                    "day" : [],
                    "night" : []
                },
                dataType : null,
                dataReady : false,
                clock : {
                    time: '',
                    date: '',
                },
            }
        },
        mounted(){
            var timerID = setInterval(this.updateTime, 1000);//Initiate Clock
            
            this.updateTime();
            this.generateTimes();
            // this.generateData();
            this.fetchData();
            this.fetchDataType();

            // this.refresh30Mins();
            // this.calculateTotalDaily();
        },
        computed:{
            shiftType: function(){//return 0 for pagi, return 1 for malam
                var current = new Date()
                // var dayStart = new Date(current.getFullYear, current.getMonth, current.getDay, 0, 0, 0)

                // var diff = endDate.getTime() - startDate.getTime();
                // var hours = Math.floor(diff / 1000 / 60 / 60);
                // diff -= hours * 1000 * 60 * 60;
                // var minutes = Math.floor(diff / 1000 / 60);

                var shift = 0;//Auto Day

                if(current.getHours() == 6){
                    if(current.getMinutes() >= 30){
                        shift = 0;
                        // console.log('1')
                    } else {
                        shift = 1;
                        // console.log('2')
                    }
                } else if (current.getHours() > 6){
                    if(current.getHours() == 20){
                        if(current.getMinutes() < 30){
                            shift = 0;
                        // console.log('3')
                        } else {
                            shift = 1;
                        // console.log('4')
                        }
                    } else if (current.getHours() < 20){
                        shift = 0;
                        // console.log('5')
                    } else {
                        shift = 1;
                        // console.log('6')
                    }
                } else {
                    shift = 1;
                        // console.log('7')
                }
                // console.log(current.getHours())
                
                return shift;
            },
        },
        sockets : {
            incomingVehicle : function(data){
                console.log(data)
                this.addOn(data);
            }
        },
        watch:{
            "clock.time" : function(){
                var clocks = this.clock.time.split(":")
                // console.log(clocks);
                if((clocks[1] == "30" || clocks[1] == "00") && clocks[2] == "00"){
                    location.reload();
                }
            }
        },
        methods:{
            consolelog(){
                console.log('data = ' + JSON.stringify(this.data))
                console.log('totalDaily = ' + JSON.stringify(this.totalDaily))
            },
            fetchData(){
                let url = "/api/vehicle-map/hourly?month=" + this.currMonth +"&year=" + this.currYear;
                this.$http.get(url)
                .then((resp)=>{
                    this.data.length = 0;
                    this.data = this.data.concat(resp.data.data);
                })
                .then(()=>{
                    this.dataReady = true;
                    this.calculateTotalDaily();
                })
                // .then(()=>{//temp
                //     console.log(this.isCurrent(7, 10))
                // })
            },
            fetchDataType(){
                let url = "/api/vehicle-map/type?month=" + this.currMonth +"&year=" + this.currYear;
                this.$http.get(url)
                .then((resp)=>{
                    this.dataType = resp.data.data;
                })
            },
            isCurrent(hourPos, date){//CURRENTLY UNUSED
                // console.log(this.currDate);
                if(date != this.currDate) return false

                let newDate = new Date();

                var format = "HH:mm";
                var time = moment(newDate , format);

                // console.log(this.times.all[hourPos].split(' - ')[0] + "; " + this.times.all[hourPos].split(' - ')[1])
                if(time.isBetween(moment(this.times.all[hourPos].split(' - ')[0] , format) , moment(this.times.all[hourPos].split(' - ')[1] , format))) return true
                else return false
            },
            generateTimes(){
                this.times.all = [
                    '06:30 - 09:00',
                    '09:00 - 10:00',
                    '10:00 - 11:00',
                    '11:00 - 12:00',
                    '12:00 - 13:00',
                    '13:00 - 14:00',
                    '14:00 - 15:00',
                    '15:00 - 16:30',
                    '16:30 - 20:29',
                    '20:30 - 22:00',
                    '22:00 - 23:00',
                    '23:00 - 00:00',
                    '00:00 - 01:00',
                    '01:00 - 02:00',
                    '02:00 - 03:00',
                    '03:00 - 04:30',
                    '04:30 - 06:29'
                ]
                
                for(var i = 0; i < 9; i++){//CURRENTLY UNUSED
                    this.times.day.push(this.times.all[i])
                }
                for(var i = 9; i < this.times.all.length; i++){//CURRENTLY UNUSED
                    this.times.night.push(this.times.all[i])
                }
            },
            generateData(){
                var compiledData = [];
                for(var j = 0; j < this.times.all.length; j++){
                    var singleData = []
                    singleData.length = 0;
                    var singleTotal = 0;
                    for(var i = 0; i < this.monthLength; i++){
                        var dat = this.randomValue();
                        singleData.push(dat);
                        singleTotal+=dat;
                    }
                    compiledData.push({
                        value : singleData,
                        total : singleTotal
                    });
                }
                this.data.length = 0;
                this.data = this.data.concat(compiledData);
            },
            calculateTotalDaily(){
                //Normalize Everything to 0
                this.totalDaily.day = new Array(this.monthLength).fill(0);
                this.totalDaily.night = new Array(this.monthLength).fill(0);

                //Start Calculation
                //DAY
                for(var i = 0; i < 9; i++){
                    for(var j = 0; j < this.monthLength; j++){
                        this.totalDaily.day[j] += this.data[i].value[j];
                    }
                }
                this.totalDaily.day.push(this.totalDaily.day.reduce((a, b) => a + b, 0))
                //NIGHT
                for(var i = 9; i < this.data.length; i++){
                    for(var j = 0; j < this.monthLength; j++){
                        this.totalDaily.night[j] += this.data[i].value[j];
                    }
                }
                this.totalDaily.night.push(this.totalDaily.night.reduce((a, b) => a + b, 0))
            },
            randomValue(){//CURRENTLY UNUSED
                return Math.floor(Math.random() * 1000) + 1;
            },
            // Fancy Clock Starts
            updateTime() {
                var week = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
                var cd = new Date();
                this.clock.time = this.zeroPadding(cd.getHours(), 2) + ':' + this.zeroPadding(cd.getMinutes(), 2) + ':' + this.zeroPadding(cd.getSeconds(), 2);
                this.clock.date = this.zeroPadding(cd.getFullYear(), 4) + '-' + this.zeroPadding(cd.getMonth()+1, 2) + '-' + this.zeroPadding(cd.getDate(), 2) + ' ' + week[cd.getDay()];
            },
            zeroPadding(num, digit) {
                var zero = '';
                for(var i = 0; i < digit; i++) {
                    zero += '0';
                }
                return (zero + num).slice(-digit);
            },
            // Fancy Clock Ends
            refresh30Mins(){
                setTimeout(function () {
                    location.reload()
                }, 1800000);//30 MINS
            },
            async addOn(data){
                var current = await this.currentPos();

                //ADD ON HUGE TABLE
                this.data[current[0]].value[current[1]] += data.total;

                //NORMALIZES NAMES
                for(var k = 0; k < data.data.length; k++){
                    if (data.data[k].name == "No Name") data.data[k].name = "Unknown"
                }

                //ADD ON TYPE TABLE
                var shift = ["pagi", "malam"]
                for(var i = 0; i < this.dataType[shift[this.shiftType]].length; i++){
                    for(var j = 0; j < data.data.length; j++){
                        if(this.dataType[shift[this.shiftType]][i].type == data.data[j].name){
                            this.dataType[shift[this.shiftType]][i].qty += data.data[j].count
                        }
                    }
                }
                // this.printDataType();
                // console.log(this.data[current[0]].value[current[1]]);
            },
            currentPos(){
                let newDate = new Date();

                var format = "HH:mm";
                var time = moment(newDate , format);

                for(var i = 0; i < this.times.all.length; i++){
                    if(time.isBetween(moment(this.times.all[i].split(' - ')[0] , format) , moment(this.times.all[i].split(' - ')[1] , format))) return [i, newDate.getDate()-1];//Hour Pos, Date
                }
            },
            printDataType(){
                console.log(JSON.stringify(this.dataType.pagi));
            }
        }
    }
</script>

<style scoped>
    .table-div{
        display: block;
        overflow: scroll;
    }
    .dataAvailable{
        color: #76FF03;
        font-weight: bold;
        font-size: 1.15em;
    }
    .bold{
        font-weight: bold;
    }
    .no-data {
        text-align: center;
        /* width: 100%; */
    }
    .lightGreen{
        background-color: #C8E6C9;
    }

    .boxHigh{
        border: 2px solid white !important;
        border-bottom: 1px solid white !important;
        
        background-color:#263238;

        font-size:110%;
        font-weight: bold;
    }

    .boxMid{
        border: 2px solid white;
        border-top: 1px solid white;
        border-bottom: 1px solid white;
        
        background-color:#263238;

        font-size:1.25em;
        font-weight: bold;
    }

    .boxLow{
        border: 2px solid white;
        border-top: 1px solid white;
        
        background-color:#263238;

        font-size:110%;
        font-weight: bold;
    }

    .currentTime{
        background-color: #fff;
        color: black;
        font-size: 1.3em;
        text-decoration: underline;
    }
    .outerLayer{
        padding:20px;
    }
    .innerLayer{
        height: 100%;
        border:1px solid white;
        border-radius: 20px;
        box-shadow: 5px 5px 5px black;
    }

    table thead tr th, table tbody tr td{
        text-align: center;
        vertical-align: middle;
    }

    .type{
        text-align: center;
        height: 100%;
        vertical-align: middle;
    }
    .type thead th{
        font-size: 130%;
        background-color: #212121;
    }
    .type{
        overflow: hidden;
    }

    .flexBox{
        display: flex;
        flex-flow: column;
    }
    .flexTop{
        flex: 0 1 auto;
    }
    .flexContent{
        flex: 1 1 auto;
    }

    /* FANCY CLOCK STARTS */
    #clock {
        font-family: 'Share Tech Mono', monospace;
        color: #ffffff;
        text-align: center;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: #daf6ff;
        text-shadow: 0 0 20px rgba(10, 175, 230, 1),  0 0 20px rgba(10, 175, 230, 0);
    }

    #clock .time {
        letter-spacing: 0.05em;
        font-size: 80px;
        padding: 5px 0;
    }
    
    #clock .date {
        letter-spacing: 0.1em;
        font-size: 24px;
    }
    /* FANCY CLOCK ENDS */
</style>